/**
 * 配置审核流程(道闸)
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 待建立审核流程车辆
Mock.mock(/visits\/\d+\/exiting\/process\/view($|\??)/, 'get' + mockSwitch, {
  'code': 0, // 0 成功，其它表示失败
  'message': 'ok', // 错误信息
  'data': {
    'visit_id': 1, // 到店记录ID
    'car_id': 1, // 车辆ID，可能为NULL
    'plate_number': '粤B12345', // 车牌
    'model_desc': '宝马X6', // 车型
    'vin': 'WDBGP57B6PB127810', // 车架号
    'exiting_rule_id': 1, // 放行规则ID
    'exiting_process_id': 1, // 对应最新放行流程ID
    'can_renew_exiting_process|1': true, // 是否可以重新发起流程
    'remark': '各位哥问过问过我饿各位哥问过问过为各位格纹顾问各位哥问过问过我饿各位哥问过问过为各位格纹顾问各位哥问过问过我饿各位哥问过问过为各位格纹顾问各位哥问过问过我饿各位哥问过问过为各位格纹顾问各位哥问过问过我饿各位哥问过问过为各位格纹顾问各位哥问过', // 备注信息
    'exiting_steps': [{
      'step_id': 1, // step_id
      'step_no': 1, // 步骤编号
      'title': '步骤一', // 步骤名称
      'status': 1, // 步骤状态
      'status_code': /approved/, // 步骤状态code: not_started|pending_review|rejected|approved
      'review_employee_choices|3': [{
        'employee_id|+1': 1, // 员工ID
        'employee_name': /张三\(续保员\)|李四\(续保员\)|王五\(续保员\)/ // 员工名称
      }],
      'operator': /张三\(续保员\)|李四\(续保员\)|王五\(续保员\)/,
      'operated_at': Mock.Random.datetime('2017-01-dd HH:mm:ss') // 审批时间
    }, {
      'step_id': 2, // step_id
      'step_no': 2, // 步骤编号
      'title': '步骤二', // 步骤名称
      'status': 1, // 步骤状态
      'status_code': /approved/, // 步骤状态code: not_started|pending_review|rejected|approved
      'review_employee_choices|3': [{
        'employee_id|+1': 1, // 员工ID
        'employee_name': /张三\(续保员\)|李四\(续保员\)|王五\(续保员\)/ // 员工名称
      }],
      'operator': /张三\(续保员\)|李四\(续保员\)|王五\(续保员\)/,
      'operated_at': Mock.Random.datetime('2017-01-dd HH:mm:ss') // 审批时间
    }, {
      'step_id': 3, // step_id
      'step_no': 3, // 步骤编号
      'title': '步骤三', // 步骤名称
      'status': 1, // 步骤状态
      'status_code': /rejected/, // 步骤状态code: not_started|pending_review|rejected|approved
      'review_employee_choices|3': [{
        'employee_id|+1': 1, // 员工ID
        'employee_name': /张三\(续保员\)|李四\(续保员\)|王五\(续保员\)/ // 员工名称
      }],
      'operator': /张三\(续保员\)|李四\(续保员\)|王五\(续保员\)/,
      'operated_at': Mock.Random.datetime('2017-01-dd HH:mm:ss') // 审批时间
    }, {
      'step_id': 4, // step_id
      'step_no': 4, // 步骤编号
      'title': '步骤四', // 步骤名称
      'status': 1, // 步骤状态
      'status_code': /pending_review/, // 步骤状态code: not_started|pending_review|rejected|approved
      'review_employee_choices|3': [{
        'employee_id|+1': 1, // 员工ID
        'employee_name': /张三\(续保员\)|李四\(续保员\)|王五\(续保员\)/ // 员工名称
      }],
      'operator': /张三\(续保员\)|李四\(续保员\)|王五\(续保员\)/,
      'operated_at': Mock.Random.datetime('2017-01-dd HH:mm:ss') // 审批时间
    }, {
      'step_id': 5, // step_id
      'step_no': 5, // 步骤编号
      'title': '步骤五', // 步骤名称
      'status': 1, // 步骤状态
      'status_code': /not_started/, // 步骤状态code: not_started|pending_review|rejected|approved
      'review_employee_choices|3': [{
        'employee_id|+1': 1, // 员工ID
        'employee_name': /张三\(续保员\)|李四\(续保员\)|王五\(续保员\)/ // 员工名称
      }],
      'operator': /张三\(续保员\)|李四\(续保员\)|王五\(续保员\)/,
      'operated_at': Mock.Random.datetime('2017-01-dd HH:mm:ss') // 审批时间
    }, {
      'step_id': null, // step_id
      'step_no': 6, // 步骤编号
      'title': '已出店', // 步骤名称
      'status': 1, // 步骤状态
      'status_code': /not_started/, // 步骤状态code: not_started|pending_review|rejected|approved
      'review_employee_choices': null,
      'operator': null,
      'operated_at': null // 审批时间
    }]
  }
})
